/**
 * El segundo par: acomoda el aviso en la ficha y arma el del cajon del carrito.
 *
 * 🔴 EL BLOQUE DE LA FICHA NO LO DIBUJA ESTE JS. Lo dibuja Liquid en
 *    `ama-segundo-par.liquid`, escondido, y aca solo se lo MUEVE a su lugar. Asi
 *    los «+ Sumar» son <form> de verdad, con el id de variante puesto por el
 *    servidor: si este archivo no carga, la clienta igual puede sumar.
 *
 * 🔴 EL AVISO SE ESCONDE SI YA TIENE DOS PARES. Ofrecer lo que ya se llevo la
 *    hace dudar de si lo tiene. Con dos en el carrito el descuento ya figura
 *    solo, con su nombre.
 *
 * 🔴 EL CAJON DEL CARRITO SE REPINTA ENTERO cada vez que se agrega algo: Shopify
 *    lo vuelve a renderizar del servidor. Por eso todo se repone con un
 *    MutationObserver — sin eso aparece una vez y no vuelve mas.
 */
(function () {
  var LENTES = window.AMA_LENTES || {};      // handle -> {p,o,v,t,u,f,d}
  var OFF = window.AMA_2DO_OFF || 0.1177;    // lo que saca el Bxgy del 2do par
  // 🔴 el porcentaje del cartel sale de los numeros, no escrito a mano: el 13/10
  //    el descuento pasa de 25% a 15% y el texto tiene que acompanar solo.
  var PCT = window.AMA_2DO_PCT_MIN || 25;

  function plata(centavos) {
    var n = centavos / 100;
    var redondo = Math.round(n * 100) % 100 === 0;
    return '$' + n.toLocaleString('es-UY', {
      minimumFractionDigits: redondo ? 0 : 2, maximumFractionDigits: 2 });
  }

  function esLente(handle) { return Object.prototype.hasOwnProperty.call(LENTES, handle); }

  // 🔴 LA MISMA CUENTA QUE HACE LA CAJA: el descuento cae sobre el precio de
  //    HOY, no sobre el original. Con «original x 0,75» el aviso decia
  //    $4.867,50 y el carrito cobraba $4.867,21.
  function precioSegundoPar(handle) {
    return Math.round(LENTES[handle].p * (1 - OFF));
  }

  // el par completo: los dos precios de hoy menos el descuento, que cae sobre el
  // mas barato de los dos. Misma cuenta que hace la caja.
  function precioDelPar(a, b) {
    var barato = Math.min(LENTES[a].p, LENTES[b].p);
    return LENTES[a].p + LENTES[b].p - Math.round(barato * OFF);
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function paresEnCarrito(carrito) {
    var n = 0;
    (carrito.items || []).forEach(function (it) { if (esLente(it.handle)) n += it.quantity; });
    return n;
  }

  // ── la ficha ────────────────────────────────────────────────
  function acomodarFicha() {
    var linea = document.querySelector('.ama-2do-linea');
    var sumar = document.querySelector('.ama-2do-sumar');
    if (linea && !linea.dataset.ama) {
      var precio = document.querySelector('.product__info-container .price, .product .price');
      if (precio) { precio.insertAdjacentElement('afterend', linea); linea.dataset.ama = '1'; linea.hidden = false; }
    }
    if (sumar && !sumar.dataset.ama) {
      // abajo de «agregar al carrito» / «comprar ahora», que es donde ya decidio
      var form = document.querySelector('.product__info-container .product-form')
        || document.querySelector('.product-form');
      if (form) { form.insertAdjacentElement('afterend', sumar); sumar.dataset.ama = '1'; sumar.hidden = false; }
    }
  }

  function ocultarSiYaTiene(pares) {
    ['.ama-2do-linea', '.ama-2do-sumar'].forEach(function (s) {
      var e = document.querySelector(s);
      if (e && e.dataset.ama) e.hidden = pares >= 2;
    });
  }

  // 🔴 SI EL LENTE DE ESTA FICHA YA ESTA EN EL CARRITO, el boton no lo agrega de
  //    nuevo: sacaria dos iguales y, con stock 2 por modelo, la deja sin poder
  //    elegir otro. Se le quitan los campos del segundo item y pasa a decir
  //    «+ Sumar», que es lo que hace.
  function ajustarBotones(carrito) {
    var forms = document.querySelectorAll('.ama-2do__form');
    if (!forms.length) return;
    var ids = {};
    (carrito.items || []).forEach(function (it) { ids[String(it.variant_id)] = true; });
    forms.forEach(function (f) {
      var yaEsta = !!ids[f.getAttribute('data-este')];
      var campos = f.querySelectorAll('[data-este-id]');
      campos.forEach(function (c) { c.disabled = yaEsta; });
      var b = f.querySelector('button');
      if (b && !b.disabled) b.textContent = yaEsta ? '+ Sumar' : '+ Llevar los dos';
    });
  }

  // ── el cajon del carrito ────────────────────────────────────
  // 🔴 EN EL CAJON VA PLEGADO Y EN LA ZONA QUE SCROLLEA, NO EN EL PIE FIJO.
  //    Estaba en `.drawer__footer`, que no scrollea: con sus 318 px el pie medía
  //    516 de 844 y a los productos les quedaba una ventana de 174 (de ~60 en el
  //    navegador de Instagram). Damián, 18/09: «no estoy viendo lo que tengo en
  //    el carrito, estoy viendo lo que dice sumá tu segundo par». Ahora va
  //    DESPUÉS de los productos, como un llamador de una línea que se abre al
  //    tocarlo. Lo que ya tiene va primero; la oferta, después.
  //
  //    `<details>` y no un botón armado a mano: el navegador ya anuncia si está
  //    abierto o cerrado, anda con teclado, y si este JS falla no queda un botón
  //    que no hace nada.
  //
  //    Arranca abierto solo en pantallas grandes y altas, donde entra sin tapar
  //    nada. Y lo que la clienta eligió se respeta: el cajón se redibuja entero
  //    cada vez que se agrega algo, así que el estado se guarda acá.
  var dosAbierto = null;
  function arrancaAbierto() {
    return window.matchMedia && window.matchMedia('(min-width: 750px) and (min-height: 800px)').matches;
  }

  function ponerEnCarrito(carrito) {
    var items = document.querySelector('cart-drawer .ama-cajon__medio cart-drawer-items');
    var pie = items ? null : document.querySelector('#main-cart-footer');
    if (!items && !pie) return;
    var raiz = items ? items.parentNode : pie;
    var viejo = raiz.querySelector('.ama-2do-cross');
    var pares = paresEnCarrito(carrito);

    if (pares !== 1) {
      if (viejo) viejo.remove();
      var vuelve = document.querySelector('cart-drawer .ama-cross:not(.ama-2do-cross)');
      if (vuelve) vuelve.hidden = false;
      return;
    }
    if (viejo) return;

    // 🔴 CON TARJETAS Y «+ SUMAR», NO CON UN ENLACE. La primera version cerraba
    //    con «Ver los lentes», que la mandaba al listado: la misma friccion que
    //    Damian marco en la ficha. Aca elige y agrega sin moverse del cajon.
    var suyo = null;
    (carrito.items || []).forEach(function (it) { if (esLente(it.handle)) suyo = it.handle; });
    if (!suyo) return;

    // los dos mas baratos que no tiene y que estan disponibles: son los que mas
    // chance tienen de cerrar el par
    var otros = Object.keys(LENTES)
      .filter(function (h) { return h !== suyo && LENTES[h].d; })
      .sort(function (a, b) { return precioDelPar(suyo, a) - precioDelPar(suyo, b); })
      .slice(0, 2);
    if (!otros.length) return;

    var d = document.createElement('details');
    d.className = 'ama-cross ama-2do-cross';
    if (dosAbierto === null ? arrancaAbierto() : dosAbierto) d.open = true;
    d.addEventListener('toggle', function () { dosAbierto = d.open; });
    d.innerHTML =
      '<summary class="ama-2do-cross__llamador">' +
        '<span class="ama-2do-cross__tx">' +
          '<span class="ama-cross__ttl">Sumá tu segundo par</span>' +
          '<span class="ama-2do-cross__off">' + PCT + '% OFF en el más barato de los dos</span>' +
        '</span>' +
        '<svg class="ama-2do-cross__flecha" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M6 9l6 6 6-6"/></svg>' +
      '</summary>' +
      '<div class="ama-cross__fila">' + otros.map(function (h) {
        var L = LENTES[h];
        return '<div class="ama-cross__it">' +
          '<a class="ama-cross__ph" href="' + esc(L.u) + '" aria-label="' + esc(L.t) + '">' +
            (L.f ? '<img src="' + esc(L.f) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="ama-cross__n" href="' + esc(L.u) + '">' + esc(L.t) + '</a>' +
          '<span class="ama-cross__p">Los dos: ' + plata(precioDelPar(suyo, h)) + '</span>' +
          '<form method="post" action="/cart/add" class="ama-cross__form">' +
            '<input type="hidden" name="id" value="' + L.v + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="ama-cross__mas">+ Sumar</button>' +
          '</form>' +
        '</div>';
      }).join('') + '</div>';
    if (items) items.insertAdjacentElement('afterend', d);
    else pie.insertAdjacentElement('afterbegin', d);

    // 🔴 UNA OFERTA POR VEZ. El cajon ya trae «Para esa ocasion» con accesorios;
    //    con las dos apiladas son cinco tarjetas y ninguna gana. Mientras vale el
    //    segundo par —que suma ~$4.000 contra ~$1.000 de un accesorio— el cross
    //    de accesorios se aparta. Vuelve solo cuando ya tiene los dos pares.
    var accesorios = document.querySelector('cart-drawer .ama-cross:not(.ama-2do-cross)');
    if (accesorios) accesorios.hidden = true;
  }

  function mirarCarrito() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { ponerEnCarrito(c); ocultarSiYaTiene(paresEnCarrito(c)); ajustarBotones(c); })
      .catch(function () {});
  }

  function iniciar() {
    acomodarFicha();
    mirarCarrito();
    var pendiente = null;
    new MutationObserver(function () {
      acomodarFicha();
      clearTimeout(pendiente);
      pendiente = setTimeout(mirarCarrito, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
